import React, { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import Login from './Login';
import Signup from './Signup';
import EmailVerification from './EmailVerification';

const AuthWrapper = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentView, setCurrentView] = useState('login'); // 'login', 'signup', 'verify'
  const [verificationEmail, setVerificationEmail] = useState('');
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if user is already authenticated
    if (AuthService.isAuthenticated()) {
      setUser(AuthService.getCurrentUser());
      setIsAuthenticated(true);
    }
    setLoading(false);

    // Listen for logout events from other windows
    const handleLogout = () => {
      setIsAuthenticated(false);
      setUser(null);
    };

    window.addEventListener('auth-logout', handleLogout);
    return () => window.removeEventListener('auth-logout', handleLogout);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleSignupSuccess = (email) => {
    setVerificationEmail(email);
    setCurrentView('verify');
  };

  const handleVerificationSuccess = () => {
    setCurrentView('login');
  };

  const handleLogout = () => {
    AuthService.signOut();
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'Arial, sans-serif'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    switch (currentView) {
      case 'signup':
        return (
          <Signup
            onSwitchToLogin={() => setCurrentView('login')}
            onSignupSuccess={handleSignupSuccess}
          />
        );
      case 'verify':
        return (
          <EmailVerification
            email={verificationEmail}
            onVerificationSuccess={handleVerificationSuccess}
            onBackToSignup={() => setCurrentView('signup')}
          />
        );
      default:
        return (
          <Login
            onLogin={handleLogin}
            onSwitchToSignup={() => setCurrentView('signup')}
          />
        );
    }
  }

  // User is authenticated, render the main app with user context
  return React.cloneElement(children, { user, onLogout: handleLogout });
};

export default AuthWrapper;
